var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNumericSortAsc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_52337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10597 15.9905C4.14079 15.9968 4.17666 16 4.21328 16C4.37681 16 4.52512 15.9345 4.63338 15.8283C4.63491 15.8268 4.63643 15.8253 4.63794 15.8238L7.43799 13.0239C7.67236 12.7894 7.67236 12.4094 7.43799 12.175C7.20361 11.9407 6.82349 11.9407 6.58911 12.175L4.81328 13.9509V0.6C4.81328 0.268799 4.54448 0 4.21328 0C3.88208 0 3.61328 0.268799 3.61328 0.6V13.9512L1.83716 12.175C1.60278 11.9407 1.2228 11.9407 0.988281 12.175C0.753906 12.4094 0.753906 12.7894 0.988281 13.0239L3.78833 15.8238C3.87801 15.9142 3.98947 15.9696 4.10597 15.9905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8149 15.9999H11.8148C11.4836 15.9999 11.2148 15.7311 11.2148 15.3999C11.2148 15.0687 11.4836 14.7999 11.8148 14.7999H13.8149C13.9252 14.7999 14.0149 14.7103 14.0149 14.5998V13.5999H12.6149C11.8428 13.5999 11.2148 12.9719 11.2148 12.1998V10.9998C11.2148 10.2278 11.8428 9.59985 12.6149 9.59985H13.8149C14.5869 9.59985 15.2149 10.2278 15.2149 10.9998V14.5998C15.2149 15.3719 14.5869 15.9999 13.8149 15.9999ZM12.6149 10.7999C12.5045 10.7999 12.4148 10.8895 12.4148 10.9998V12.1998C12.4148 12.3103 12.5045 12.3999 12.6149 12.3999H14.0149V10.9998C14.0149 10.8895 13.9252 10.7999 13.8149 10.7999H12.6149Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.204 6.39995C13.2077 6.40002 13.2113 6.40005 13.2149 6.40005C13.2186 6.40005 13.2222 6.40002 13.2258 6.39995H14.6149C14.9461 6.39995 15.2149 6.13115 15.2149 5.79995C15.2149 5.46875 14.9461 5.19995 14.6149 5.19995H13.8149V0.6C13.8149 0.268799 13.5461 0 13.2149 0H11.8148C11.4836 0 11.2148 0.268799 11.2148 0.6C11.2148 0.931201 11.4836 1.2 11.8148 1.2H12.6149V5.19995H11.8148C11.4836 5.19995 11.2148 5.46875 11.2148 5.79995C11.2148 6.13115 11.4836 6.39995 11.8148 6.39995H13.204Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_52337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNumericSortAsc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/numeric-sort-asc.24e39e29.svg";
export { ForwardRef as ReactComponent };